import Routes from "./routes/Routes";
import { Toaster } from "react-hot-toast";
import { useSelector } from "react-redux";
import { RootState } from "app/lib/store/store";
import SessionTimeoutModal from "app/components/common/SessionTimoutModel";
import InactivityTracker from "app/components/common/InactivityTracker";

function App() {
  const currentStep = useSelector(
    (state: RootState) => state.loanTypesSteps.currentStep
  );

  const isBaseUrl = window.location.pathname === "/";
  const shouldShowSessionComponents = !(isBaseUrl && currentStep === 0);

  return (
    <>
      <Routes />
      <Toaster />
      {shouldShowSessionComponents && <SessionTimeoutModal />}
      {shouldShowSessionComponents && <InactivityTracker />}
    </>
  );
}

export default App;
